/**新增比较项弹框 */
<template>
  <el-popover
    :placement="placement"
    :hide-after="0"
    popper-class="header-popover-card"
    :width="165"
    :visible="visible"
  >
    <template #reference>
      <slot name="content"></slot>
    </template>
    <template #default>
      <div class="popover-content">
        <div class="popover-title">标题</div>
        <div class="popover-text">
          <div class="text-input">
            <el-input
              v-model="optionName"
              placeholder="请输入比较项名称"
              maxlength="30"
            />
          </div>
        </div>
        <div class="popover-button">
          <el-button @click="handleClickCancel">取消</el-button>
          <el-button type="primary" @click="handleClickConfirm">确定</el-button>
        </div>
      </div>
    </template>
  </el-popover>
</template>

<script setup>
import { ref, defineProps, watch, defineEmits } from "vue";
import { bus } from "@/utils/mitt.js";
import {
  COMPARE_TITLE_VISIBLE,
  COMPARE_TITLE_TYPE,
} from "@/constant/compare.js";

const emits = defineEmits(["update:visible", "add"]);
const props = defineProps({
  placement: {
    type: String,
  },
  visible: {
    type: Boolean,
    default: false,
  },
});
const optionName = ref("");

//取消添加比较项
const handleClickCancel = () => {
  closePopper();
};
//确认添加比较项
const handleClickConfirm = () => {
  let params = {
    name: optionName.value,
    label: optionName.value,
    type: COMPARE_TITLE_TYPE.CUSTOM,
    show: COMPARE_TITLE_VISIBLE.SHOW,
    columnWidth: null,
  };
  emits("add", params);
  closePopper();
};
//关闭card
const closePopper = () => {
  optionName.value = "";
  emits("update:visible", false);
};
</script>

<style lang="scss" scoped>
.header-popover-card {
  .popover-content {
    padding: 10px 10px;
    .popover-title {
      font-size: 14px;
    }
    .popover-text {
      width: 100%;
      margin-top: 10px;
      .text-input {
        height: 30px;
        width: 100%;
      }
      :deep(.el-input__inner) {
        font-size: 12px;
      }
    }
    .popover-button {
      display: flex;
      justify-content: space-between;
      margin-top: 15px;
      .el-button {
        width: 50px;
        height: 26px;
        border-radius: 5px;
        font-size: 12px;
      }
    }
  }
}
</style>
